import { HttpHandler } from 'msw'

import { deletePlanogram } from './deletePlanogram'
import { getAllPlanograms } from './getAllPlanograms'
import { getPlanogram } from './getPlanogram'

export const planograms: HttpHandler[] = [
    deletePlanogram,
    getAllPlanograms,
    getPlanogram,
]
